import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

const JiraAgenticSummaryViewRelayProvider = {
	get(): boolean {
		// No-exposure check: gates whether `rovoEnablementStatus` is fetched for the agentic summary
		// tab. Exposure is fired at the point the agentic summary view actually renders, not here.
		return UNSAFE_noExposureExp('jira_agentic_summary_view')[0].get('isEnabled', false);
	},
};

export default JiraAgenticSummaryViewRelayProvider;
